<template src="../templates/bull.pug" lang="pug" />

<script>
import _filter from "lodash/filter"
import {mapActions, mapGetters, mapMutations} from "vuex"
import differenceInYears from "date-fns/difference_in_years"
import differenceInMonths from "date-fns/difference_in_months"
import {parse} from "date-fns"

export default {
    name: "Bull",
    data() {
        return {
            searchInput: '',
            selectedAnimal: null,
        }
    },
    computed: {
        ...mapGetters([
            'bulls',
            'bullLoading',
            'selectedFarm',
            'farmAnimalType',
            'countBullsByType',
            'filteredBullAnimals',
            'filterBullTypes',
            'filterBull',
            'isUserVisitor',
            'isColumnOrdered'
        ]),
        filteredAnimals() {
            if (this.searchInput.length > 0) {
                let self = this
                return _filter(this.bulls, function(a) {
                    let str = a.buckleNumber.toString()
                    return str.includes(self.searchInput)
                })
            } else {
                return this.filteredBullAnimals
            }
        }
    },
    created() {
        this.fetchBulls()
    },
    methods: {
        ...mapActions(['fetchBulls', 'deleteBull']),
        ...mapMutations([
            'updateBullFilterType',
            'resetFilterType',
            'updateTableOrder'
        ]),
        getAge(birthday) {
            let years = differenceInYears(Date.now(), new Date(birthday * 1000))
            let months = differenceInMonths(parse(Date.now()), new Date(birthday * 1000))
            let age = ''
            if (years > 0) {
                age += years + ' years '
            }
            if (months - years * 12 > 0) {
                age += months - years * 12 + ' months'
            }
            if (months === 0) {
                age += 'less than 1 months'
            }
            return age
        },
        deleteBullDialog(animal) {
            this.$dialog
                    .confirm(this.$t('cattle.dialog.message', { buckle: animal.buckleNumber }), {
                        okText: this.$t('button.true'),
                        cancelText: this.$t('button.false')
                    })
                    .then(() => {
                        this.deleteBull(animal)
                    })
                    .catch(() => {})
        },
        goToBullUpdate(bull) {
            this.$router.push({
                name: 'edit-bull-form',
                params: {
                    bullId: bull.id,
                    bullToUpdate: {
                        id: bull.id,
                        birthday: bull.birthday,
                        buckleNumber: bull.buckleNumber,
                        building: bull.building,
                        type: bull.type,
                        isBought: bull.isBought,
                        bullRating: {
                            id: bull.bullRating.id,
                            fertility: bull.bullRating.fertility,
                            milkProduction: bull.bullRating.milkProduction,
                            udderHealth: bull.bullRating.udderHealth,
                            sicknessProprensity: bull.bullRating.sicknessProprensity,
                        }
                    }
                }
            })
        },
        goToBullCard(bull) {
            this.$router.push({
                name: 'bull-card',
                params: {
                    bullId: bull.id,
                    bullToView: bull
                }
            })
        }
    }

}
</script>

<style lang="sass" scoped>
    @import '../sass/mixin/color'
    @import '../sass/mixin/flex'

    #bull
        .filter-container
            .filters-list
                .filter-building
                    background-color: $dd-lime-green
                .filter-type
                    background-color: $dd-soft-pink
        .content
            .button-row
                .round-button-effect
                    padding: 1em
                    .round-button-icon
                        fill: $dd-very-dark-gray
                        box-shadow: 0 0 0 4px $dd-very-dark-gray
                    &:hover
                        svg
                            background: $dd-very-dark-gray none repeat scroll 0 0
                            fill: white
            .cell-buckle-number
                cursor: pointer
                &:hover
                    font-size: 18px
                    font-weight: bold
                    color: $dd-light-orange

        .table-header
            background-color: $dd-very-dark-gray
</style>